/**
 * product-media-carousel-mobile.js
 * Location: assets/product-media-carousel-mobile.js
 *
 * Initialises the mobile product media carousel (Splide.js), synced lightbox,
 * and pinch-to-zoom on lightbox images.
 *
 * Depends on:
 *   - Splide.js (splide.min.js) loaded before this file
 *   - window.pmcSectionId  set inline by the Liquid snippet
 */

(function () {
  'use strict';

  /* ── Guard: mobile only + Splide available ────────────────────────── */

  if (window.innerWidth > 749) return;

  if (typeof Splide === 'undefined') {
    console.warn('[pmc] Splide.js not found. Make sure splide.min.js is loaded before product-media-carousel-mobile.js.');
    return;
  }
  var sectionId  = window.pmcSectionId;
  var mainEl     = document.getElementById('pmc-main-' + sectionId);
  var lightboxEl = document.getElementById('pmc-lightbox-' + sectionId);
  var lbSplideEl = document.getElementById('pmc-lb-' + sectionId);

  if (!mainEl || !lightboxEl || !lbSplideEl) return;

  var overlayEl  = lightboxEl.querySelector('.pmc-lightbox__overlay');
  var closeBtn   = lightboxEl.querySelector('.pmc-lightbox__close');
  var counterCur = lightboxEl.querySelector('.pmc-lightbox__current');
var counterCurMain = mainEl.querySelector('.pmc-lightbox__current');

  /* ── 1. Init main carousel ────────────────────────────────────────── */

  var mainSplide = new Splide(mainEl, {
    type      : 'loop',
    perPage   : 1,
    perMove : 1,
    gap       : 0,
    pagination: true,
    arrows    : false,
    drag      : true,
    lazyLoad  : 'nearby',
    snap : true,
  });


  /* ── 2. Init lightbox carousel ────────────────────────────────────── */

  var lbSplide = new Splide(lbSplideEl, {
    type      : 'slide',
    perPage   : 1,
    perMove : 1,
    gap       : 0,
    pagination: false,
    arrows    : true,
    drag      : true,
    keyboard  : 'focused',
    snap : true,
  });

  mainSplide.mount();
  lbSplide.mount();


  /* ── 3. Keep carousels in sync ────────────────────────────────────── */

  var isSyncing = false;

  mainSplide.on('moved', function (newIndex) {
    if (isSyncing) return;
    isSyncing = true;
    lbSplide.go(newIndex);
    isSyncing = false;
    updateCounter(newIndex);
  });

  lbSplide.on('moved', function (newIndex) {
    if (isSyncing) return;
    isSyncing = true;
    mainSplide.go(newIndex);
    isSyncing = false;
    updateCounter(newIndex);
    resetZoomOnSlide(newIndex);
  });

  function updateCounter(index) {
    if (counterCur) {
      counterCur.textContent = index + 1;
      counterCurMain.textContent = counterCur.textContent;
    }
  }


  /* ── 4. Open lightbox ─────────────────────────────────────────────── */

  mainEl.querySelectorAll('.pmc-slide-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      openLightbox(parseInt(btn.dataset.index, 10));
    });
  });

  function openLightbox(index) {
    lightboxEl.removeAttribute('inert');
    lightboxEl.setAttribute('aria-hidden', 'false');
    lightboxEl.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    setTimeout(function () {
      lbSplide.go(index);
      updateCounter(index);
      closeBtn.focus();

      // Correct Splide's stale transform using real container width
      var list = lbSplideEl.querySelector('.splide__list');
      var containerWidth = lbSplideEl.offsetWidth;
      if (list && containerWidth) {
        list.style.transform = 'translateX(-' + (index * containerWidth) + 'px)';
      }
    }, 50);
  }


  /* ── 5. Close lightbox ────────────────────────────────────────────── */

  function closeLightbox() {
    lightboxEl.classList.remove('is-open');
    lightboxEl.setAttribute('aria-hidden', 'true');
    lightboxEl.setAttribute('inert', '');
    document.body.style.overflow = '';
    resetAllZoom();
  }

  overlayEl.addEventListener('click', closeLightbox);
  closeBtn.addEventListener('click', closeLightbox);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lightboxEl.classList.contains('is-open')) {
      closeLightbox();
    }
  });


  /* ── 6. Pinch-to-zoom ─────────────────────────────────────────────── */

  var zoomStates = {}; // keyed by slide index

  function getZoomState(index) {
    if (!zoomStates[index]) {
      zoomStates[index] = {
        scale      : 1,
        x          : 0,
        y          : 0,
        startDist  : 0,
        startScale : 1,
        isDragging : false,
        lastX      : 0,
        lastY      : 0,
      };
    }
    return zoomStates[index];
  }

  function applyTransform(img, state) {
    img.style.transform  = 'translate(' + state.x + 'px, ' + state.y + 'px) scale(' + state.scale + ')';
    img.style.transition = 'none';
  }

  function resetZoom(img, state) {
    state.scale          = 1;
    state.x              = 0;
    state.y              = 0;
    img.style.transform  = '';
    img.style.transition = 'transform .25s ease';
  }

  function resetZoomOnSlide(index) {
    var slides = lbSplideEl.querySelectorAll('.pmc-lb-slide');
    var slide  = slides[index];
    if (!slide) return;
    var img = slide.querySelector('.pmc-pinch-zoom img');
    if (!img) return;
    resetZoom(img, getZoomState(index));
  }

  function resetAllZoom() {
    lbSplideEl.querySelectorAll('.pmc-pinch-zoom img').forEach(function (img, i) {
      resetZoom(img, getZoomState(i));
    });
  }

  function clampPan(state, img) {
    if (state.scale <= 1) { state.x = 0; state.y = 0; return; }
    var maxX = (img.naturalWidth  * state.scale - window.innerWidth)  / 2;
    var maxY = (img.naturalHeight * state.scale - window.innerHeight) / 2;
    state.x  = Math.max(-Math.max(maxX, 0), Math.min(Math.max(maxX, 0), state.x));
    state.y  = Math.max(-Math.max(maxY, 0), Math.min(Math.max(maxY, 0), state.y));
  }

  function touchDist(touches) {
    return Math.hypot(
      touches[0].clientX - touches[1].clientX,
      touches[0].clientY - touches[1].clientY
    );
  }

  lbSplideEl.querySelectorAll('.pmc-pinch-zoom').forEach(function (container, slideIndex) {
    var img     = container.querySelector('img');
    var state   = getZoomState(slideIndex);
    var touches = [];
    var lastTap = 0;

    /* touchstart */
    container.addEventListener('touchstart', function (e) {
      touches = Array.from(e.touches);

      if (touches.length === 2) {
        e.preventDefault();
        state.startDist  = touchDist(touches);
        state.startScale = state.scale;
      } else if (touches.length === 1 && state.scale > 1) {
        state.isDragging = true;
        state.lastX      = touches[0].clientX;
        state.lastY      = touches[0].clientY;
      }
    }, { passive: false });

    /* touchmove */
    container.addEventListener('touchmove', function (e) {
      touches = Array.from(e.touches);

      if (touches.length === 2) {
        e.preventDefault();
        state.scale = Math.min(5, Math.max(1, state.startScale * (touchDist(touches) / state.startDist)));
        clampPan(state, img);
        applyTransform(img, state);
        lbSplide.options = { drag: false }; // disable swipe while pinching

      } else if (touches.length === 1 && state.isDragging && state.scale > 1) {
        e.preventDefault();
        state.x    += touches[0].clientX - state.lastX;
        state.y    += touches[0].clientY - state.lastY;
        state.lastX = touches[0].clientX;
        state.lastY = touches[0].clientY;
        clampPan(state, img);
        applyTransform(img, state);
      }
    }, { passive: false });

    /* touchend */
    container.addEventListener('touchend', function () {
      state.isDragging = false;

      /* Snap back if barely pinched */
      if (state.scale <= 1.05) {
        state.scale          = 1;
        state.x              = 0;
        state.y              = 0;
        img.style.transform  = '';
        img.style.transition = 'transform .2s ease';
      }

      /* Re-enable swipe when fully zoomed out */
      if (state.scale <= 1) {
        lbSplide.options = { drag: true };
      }
    }, { passive: true });

    /* Double-tap: toggle zoom */
    container.addEventListener('touchend', function () {
      var now = Date.now();
      if (now - lastTap < 300) {
        if (state.scale > 1) {
          resetZoom(img, state);
          lbSplide.options = { drag: true };
        } else {
          state.scale = 2.5;
          applyTransform(img, state);
          lbSplide.options = { drag: false };
        }
      }
      lastTap = now;
    }, { passive: true });
  });

})();
function initMobileFullscreenGallery() {
  // intentionally empty — handled by product-media-carousel-mobile.js
}